module.exports = __webpack_public_path__ + "img/1-1.857e71f4.jpg";